import { LAGO_PLAN_MAP } from './lagoPlanMap';
import { resolveLagoAddonCode } from './lagoAddonMap';

function isPlanMapped(chargebeeId?: string): boolean {
  return !!chargebeeId && chargebeeId in LAGO_PLAN_MAP;
}

function isAddonMapped(item: string | undefined, basePlanId: string | undefined): boolean {
  if (!item) return true;

  return resolveLagoAddonCode(item, basePlanId) !== item;
}

export function isRoundReadyPlanSet(plans: SubscriptionModel[]): boolean {
  return plans.every((plan) => {
    if (!isPlanMapped(plan.standard?.chargebeeId)) return false;
    if (!isPlanMapped(plan.super?.chargebeeId)) return false;

    const basePlanId = plan.standard?.chargebeeId;

    return [
      plan.fitness?.standard?.chargebeeId,
      plan.fitness?.super?.chargebeeId,
      plan.subscriptionUpsells?.groinFitness?.standard?.chargebeeId,
      plan.subscriptionUpsells?.sexologyCourses?.standard?.chargebeeId,
      plan.subscriptionUpsells?.guidedMeditations?.standard?.chargebeeId,
    ].every(item => isAddonMapped(item, basePlanId));
  });
}
